import { BaseService } from '../../infra/base.service'
import type { CreateDeviceDto } from './create-device.dto'
import { UAParser } from 'ua-parser-js'
import type { DevicesRepository } from './devices.repository'
import type { DeviceEntity } from './device.entity'
import type { SendPushNotification } from './send-push-notification.dto'

export class DevicesService extends BaseService<DeviceEntity> {
    constructor(private rep: DevicesRepository) {
        super(rep)
    }

    getDeviceId() {
        let deviceId = localStorage.getItem('device_id_for_' + window.store?.company?.companyId)
        return deviceId || null
    }

    async refreshToken() {
        const deviceId = this.getDeviceId()
        const device = await this.rep.refreshToken(deviceId)
    }

    running = false
    async upsertDevice() {
        if (this.running) return
        this.running = true
        await new Promise((resolve) => setTimeout(resolve, 1500))
        try {
            const companyId = window.store.token.companyId
            if (!companyId) return
            let fcmToken = undefined
            if (Notification.permission === 'granted') {
                fcmToken = await window.api.utils.utils.getFcmTokenWithFirebase()
                if (!fcmToken) fcmToken = undefined
            }

            let fullVersion = null
            try {
                if (navigator['userAgentData']) {
                    const _version = await navigator['userAgentData'].getHighEntropyValues(['fullVersionList'])
                    if (_version?.fullVersionList) {
                        fullVersion = _version.fullVersionList[_version.fullVersionList.length - 1]?.version
                    }
                }
            } catch (error) {}

            const { browser, cpu, device, os } = UAParser(navigator.userAgent)
            let description = ''
            if (device?.vendor) {
                description = device.vendor + ' ' + device.model
            }
            if (os?.name) {
                if (description) description += ' - '
                description += os.name + ' ' + os.version
            }
            if (description && cpu?.architecture) {
                description += ' (' + cpu.architecture + ')'
            }
            if (browser?.name) {
                if (description) description += ' - '
                description += browser.name + ' ' + (fullVersion || browser.version)
            }
            if (await window.api.utils.utils.isInstalled()) {
                if (description) description += ' (aplicativo)'
            }

            if (!description) description = undefined

            const dto: CreateDeviceDto = {
                fcmToken,
                label: undefined,
                description,
            }

            let deviceId = localStorage.getItem('device_id_for_' + companyId)
            if (deviceId) {
                try {
                    await this.update(deviceId, dto)
                    return deviceId
                } catch (error) {
                    // se o device não existe mais (ex. foi excluído)
                    console.log('Device update error:', error)
                    if (!error?.includes('not found')) return
                }
            }

            const newDevice: DeviceEntity = await this.create(dto)
            if (!newDevice) {
                return null
            }
            localStorage.setItem('device_id_for_' + companyId, newDevice.deviceId)
        } catch (error) {
            window.log('[devices.service.ts] Error in upsertDeviceId', 'error', error)
            return null
        } finally {
            this.running = false
        }
    }

    async requestLoginByDevice() {
        const deviceId = this.getDeviceId()
        if (!deviceId) return null
        return await this.rep.requestLoginByDevice(deviceId)
    }

    async requestJWTTokenByDevice() {
        // solicita login pelo device, que possui o cookie já armazenado
        // e retorna o token JWT
        const companyId = window.store?.company?.companyId
        if (!companyId) return null
        return await this.rep.requestJWTTokenByDevice(companyId)
    }

    async sendPushNotification(dto: SendPushNotification) {
        return await this.rep.sendPushNotification(dto)
    }
}
